<mat-sidenav-container class="imei-info-sidenav-container">
  <mat-sidenav #imeisidenav position="end" mode="over" [(opened)]="opened" (opened)="events.push('open!')"
              (closed)="events.push('close!')">
              <pgh-imei-info (closeEvent)="closeSideNav()" [imeiInfoDeviceType]="imeiInfoDeviceType"></pgh-imei-info>
  </mat-sidenav>

  <mat-sidenav-content>

<div id="body-container">

  <div class="background-blue" *ngIf="!isOnboardingFlow">
    <div class="page-title-container container">
      <h1 style="font-size:22.5px;"><adp-label labelKey="RegisterSmartwatch_PageTitle"></adp-label></h1>
    </div>
  </div>

  <ng-container>


    <div class="back container pt-4" style="display:flex;" *ngIf="!isAdditionalDeviceFlow">

          <div style="white-space: nowrap;">
            <button class="link" (click)="handleBack()" style="padding-left:0px;"><mat-icon
              style="padding-top:6px;">keyboard_arrow_left</mat-icon>{{backLabel}}</button>
          </div>
          <div style="width:100%;"></div>
          <div style="white-space: nowrap;" *ngIf="state != states.GenerateQRCode">
            <button class="link" (click)="handleExitToDashboard()" style="padding-left:0px;padding-top:8px;"><adp-label labelKey="Global_Button_Dashboard"></adp-label></button>
          </div>
    </div>
    <div class="back container pt-4" style="display:flex;" *ngIf="isAdditionalDeviceFlow">
      <div style="white-space: nowrap;">
        <button class="link" (click)="handleBack()" style="padding-left:0px;"><mat-icon
          style="padding-top:6px;">keyboard_arrow_left</mat-icon><adp-label labelKey="Global_Button_Back"></adp-label></button>
      </div>
      <div style="width:100%;"></div>
      <div style="white-space: nowrap;">
        <button class="link" (click)="handleExitToDashboard()" style="padding-left:0px;padding-top:8px;"><adp-label labelKey="Global_Button_Dashboard"></adp-label></button>
      </div>
    </div>


    <div class="container phone-registration-page">
      <pgh-damage-questionnaire *ngIf="state===states.RegisterSmartwatchDamageQuestionnaire" [isOnboardingFlow]="isOnboardingFlow"
      (nextEvent)="handleRegisterQuestionnaire({'data': $event,'state' : states.RegisterSmartwatchNextSteps})">
      </pgh-damage-questionnaire>
      <pgh-next-steps *ngIf="state === states.RegisterSmartwatchNextSteps" [isOnboardingFlow]="isOnboardingFlow" (nextEvent)="changeState(states.RegisterImeiQuestionnaire)"
       [nextStepsInfoDeviceTypeTemplate]="nextStepsInfoDeviceTypeTemplate" [preSelectedDevice]="preSelectedDevice"></pgh-next-steps>

       <pgh-imei-questionnaire *ngIf="state === states.RegisterImeiQuestionnaire"
        [deviceTypeCode]="additionalDeviceTypeCode"
        [isOnboardingFlow]="isOnboardingFlow"
        (nextEvent)="handleImeiQuestionnaireCompleted($event)"
        (viewIMEIInfo)="sidenav.toggle()"></pgh-imei-questionnaire>

       <pgh-imei-lookup *ngIf="state === states.RegisterSmartwatchIMEIInfo"
        [imeiLookupDeviceTypeTemplate]="imeiLookupDeviceTypeTemplate"
        [isOnboardingFlow]="isOnboardingFlow"
        (viewIMEIInfo)="sidenav.toggle()"
        (nextEvent)="handleImeiLookupCompleted($event)">
      </pgh-imei-lookup>

      <pgh-serial-lookup *ngIf="state === states.SerialInfo"
        [isOnboardingFlow]="isOnboardingFlow"
        [serialLookupDeviceTypeTemplate]="serialLookupDeviceTemplate.Smartwatch"
        (nextEvent)="handleSerialLookupCompleted($event)"></pgh-serial-lookup>

      <pgh-cellular-device-info-form class="step-item" *ngIf="state === states.ProvideAdditionalInfo && hasImei"
        preHeaderTextSfKey="RegisterCellularDevice_PreSelectedDevice_DisplayName_Text"
        headerTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Header_Text"
        bodyTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Body_Text"
        submitButtonLabelSfKey="Global_Button_Next"
        [preSelectedDevice]="preSelectedDevice"
        [devicesFromAllInventories]="devicesFromAllInventories"
        [serialSearchResponse]="imeiStepResult.imeiLookupResult"
        (formSubmitted)="handleDeviceInfoFormSubmitted($event)"
        ></pgh-cellular-device-info-form>

      <pgh-non-cellular-device-info-form class="step-item" *ngIf="state === states.ProvideAdditionalInfo && !hasImei"
        preHeaderTextSfKey="RegisterCellularDevice_PreSelectedDevice_DisplayName_Text"
        headerTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Header_Text"
        bodyTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Body_Text"
        submitButtonLabelSfKey="Global_Button_Next"
        [preSelectedDevice]="preSelectedDevice"
        [devicesFromAllInventories]="devicesFromAllInventories"
        [deviceType]="EssItemGroupEnum.SmartWatch"
        (formSubmitted)="handleDeviceInfoFormSubmitted($event)"
        ></pgh-non-cellular-device-info-form>

      <pgh-scan-qrcode *ngIf="state === states.GenerateQRCode" [isAdditionalDeviceFlow]="isAdditionalDeviceFlow" [additionalDeviceTypeCode]="'SMAR'" [imeiOrSerialNum]="imeiStepResult?.imei ?? serialStepResult?.serial" [invitationId]="invitationId" [invitationCode]="invitationCode"></pgh-scan-qrcode>
    </div>
  </ng-container>
</div>.

</mat-sidenav-content>
</mat-sidenav-container>
